import MainTabs from './main.tabs';

export default {
  MainTabs,
};
